import styled from "@emotion/styled";
import { AccordionContainerProps } from "./Accordion.types";
import { colorGuide } from "../../theme/colors";
import { generateAccordionContainerStyles } from "../../utils";

// Accordion Container
export const AccordionContainer = styled.div<AccordionContainerProps>`
  margin-bottom: 8px;
  gap: ${({ isOpen }) => (isOpen ? "8px" : "12px")};
  ${(props) => generateAccordionContainerStyles(props)};
`;

// Accordion Header
export const AccordionHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  gap: 8px;
  align-self: stretch;
  cursor: pointer;
  color: ${colorGuide.lightComponents.accordion.color};
`;

// Chevron Icon
export const ChevronIcon = styled.i<{ isOpen: boolean }>`
  width: 12px;
  height: 8px;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
  color: ${colorGuide.lightComponents.accordion.color};
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Accordion Content
export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

// Styled Container for Accordion Detail
export const AccordionDetailContainer = styled.div`
  height: auto;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 8px;
`;

// Styled Line
// Accordion.styles.ts
export const AccordionLine = styled.div<{ lineColor?: string }>`
  align-self: center;
  height: 1px;
  width: 100%;
  background-color: ${({ lineColor }) =>
    lineColor || colorGuide.lightComponents.accordion.accordionLineColor};
`;
